import { HttpParams } from '@angular/common/http';
import { isNil } from 'lodash';

export function objectToParams(object: { [key: string]: string | number | boolean | Date | Array<string | number | boolean> }): HttpParams {
  return new HttpParams({ fromObject: getObjectWithoutEmptyProp(object) });
}

export function getObjectWithoutEmptyProp(obj) {
  for (const key in obj) {
    if (isNil(obj[key])) {
      delete obj[key];
    }
  }
  return obj;
}
